import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, SubTopBar } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'reactstrap';
import { AppStore } from '../Core/AppStore';

@autoinject
@observer
export class BIViewNav extends React.Component {
    public render() {
        const location = `/bi`;
        return (
            <SubTopBar hide={this.appStore.hiddenHeader}>
                <ul className="nav d-flex">
                    <li className="nav-item mx-2">
                        <LinkContainer to={`${location}/dashboards`} className="nav-link stat-link fw-bold">
                            <Button color="link" className="nav-link fw-bold px-0" onClick={this.toggleNavbar}>
                                Dashboards
                            </Button>
                        </LinkContainer>
                    </li>

                    <li className="nav-item mx-2">
                        <LinkContainer to={`${location}/reports`} className="nav-link stat-link fw-bold">
                            <Button color="link" className="nav-link fw-bold px-0" onClick={this.toggleNavbar}>
                                Reports
                            </Button>
                        </LinkContainer>
                    </li>
                </ul>
            </SubTopBar>
        );
    }

    @bind
    @action
    private toggleNavbar() {
        this.collapsed = !this.collapsed;
    }

    @observable
    private collapsed = false;

    @inject
    private appStore!: AppStore;
}
